export default {
      id: "add-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#add",
      toString: function () {
        return this.url;
      }
    }